import { render } from "./users_list.vue?vue&type=template&id=52b2dd28&scoped=true"
import script from "./users_list.vue?vue&type=script&lang=js"
export * from "./users_list.vue?vue&type=script&lang=js"

import "./users_list.vue?vue&type=style&index=0&id=52b2dd28&scoped=true&lang=css"

import exportComponent from "/var/www/host/imc/tender/dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52b2dd28"],['__file',"vue/js/components/shared/users/users_list.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "52b2dd28"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('52b2dd28', __exports__)) {
    console.log('reload')
    api.reload('52b2dd28', __exports__)
  }
  
  module.hot.accept("./users_list.vue?vue&type=template&id=52b2dd28&scoped=true", () => {
    console.log('re-render')
    api.rerender('52b2dd28', render)
  })

}


export default __exports__